import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

const apiUrl = environment.SERVER_URL;
const headers = new HttpHeaders({
  "Content-Type": "application/json",
});

const httpOptions = {
  headers: headers,
  observe: "response" as "body",
};

@Injectable({
  providedIn: "root",
})
export class ApiCalls {
  constructor(private http: HttpClient) {}

  private post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(url, body, httpOptions);
  }

  private get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, httpOptions);
  }

  public getTemperatureByNode(
    nodeId: string,
    days: string
  ): Observable<IApiResponse> {
    return this.post<IApiResponse>(`${apiUrl}/temperatureData`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getAudioByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/audiodata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getCo2ByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/coleveldata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }
  public getHumidityByNode(
    nodeId: string,
    days: string
  ): Observable<IApiResponse> {
    return this.post<IApiResponse>(`${apiUrl}/humiditydata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getSoilHumidityByNode(
    nodeId: string,
    days: string
  ): Observable<IApiResponse> {
    return this.post<IApiResponse>(`${apiUrl}/soilhumiditydata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getLocationByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/latlongdata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getIRLightByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/lightdata/ir`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getUVLightByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/lightdata/uv`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getVISLightByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/lightdata/vis`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getElevationByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/elevationdata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getAirQualityByNode(nodeId: string, days: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/airqualitydata`, {
      device_id: nodeId,
      no_of_days: days,
    });
  }

  public getAverageValuesByAttrbute(
    nodeId: string,
    attribute_name: string
  ): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/average`, {
      device_id: nodeId,
      attribute_name,
    });
  }

  public getForestFireAlerts(nodeId: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/forest-fire-alerts`, {
      device_id: nodeId,
    });
  }

  public getTreeHealthAlerts(nodeId: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/tree-health-alerts`, {
      device_id: nodeId,
    });
  }

  public getHeatIndex(nodeId: string): Observable<any> {
    return this.post<IApiResponse>(`${apiUrl}/heat-index`, {
      device_id: nodeId,
    });
  }

  public getAllNodes(): Observable<any> {
    return this.get<IApiResponse>(`${apiUrl}/nodes`);
  }

  public getRecentAlerts(): Observable<any> {
    return this.http.get<any>(apiUrl + "alertsdata", httpOptions).pipe();
  }
}
